import { render, staticRenderFns } from "./EditDoorToDoor.vue?vue&type=template&id=31a919d8"
import script from "./EditDoorToDoor.vue?vue&type=script&lang=js"
export * from "./EditDoorToDoor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports